import Vue from 'vue';
import Vuex from 'vuex';
import router from '@/router';
import axios from 'axios';
//import fs, { Stats } from 'fs';
//import _ from 'lodash'; //Para ordenamiento de arreglos.
//import { push } from 'core-js/fn/array';
//import { strictEqual } from 'assert';
//import { prependListener } from 'process';
// import path from 'path';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        version: '1.0.4',
        appTitle: 'Planificador Semestral',
        uiaLogoBlanco: require('@/assets/logo_blanco.png'),
        uiaLogoRojo: require('@/assets/logo_rojo.png'),
        uiaLogoPositivo: require('@/assets/logotipo_positivo.png'),
        uiaRubricaSimple: require('@/assets/rubrica_simple.png'),
        logoAOCS: require('@/assets/aocs1.png'),
        bWaitCursor: false,
        bFailedLogin: false,
        isAuthenticated: false,
        bInactiveUser: false,

        userName: '', //Nombre del usuario logueado.
        bAlumnoPrueba: false, //Indica si el usuario logueado es un alumno de pruebas.
        numCuenta: '',
        numCuentaAlumnoPrueba: 0,

        planID: 0,
        periodoInicioID: 0, //1 = primavera, 2 = verano, 3 = otoño.
        anioInicio: 0,
        semestres: [],

        bAdmin: false,
        //authHeader: null,
        idToken: null,
        userID: null,
        //userType: 0, //1 = superadmin, 2 = admin. prepago, 3 = admin. de seguimiento, 4 = encuestado.

        user: {
            nombre: '',
            apPaterno: '',
            apMaterno: '',
            tipoid: '',
            numCuenta: '',
            carrera: '',
        },
        users: null,
        administrators: null,

        bDuplicatedUserError: false, //Indica que hay que desplegar un mensaje de error ya que se intentó registrar a un usuario con un correo previamente registrado.

        userTypes: [],
        selectedUserTypeIndex: -1,

        bServerResponse: false, //Indica si el servidor ya respondió ante un request de borrado de cuestionario.

        bSearchNewUser: false, //Indica si se debe buscar el índice del usuario que se acaba de registrar.
        bSearchNewPlanEstudios: false, //Indica si se debe buscar el índice del plan de estudios que se acaba de registrar.
        bSearchNewCourse: false, //Indica si se debe buscar el índice de la materia que se acaba de registrar.
        bSearchDivision: false,
        bDivisionFound: false,
        bSearchNewPaquete: false,
        materiaID: 0, //Materia seleccionada en la ventana Planes de Estudios.

        newUserEmail: '', //Indica el email de un nuevo usuario registrado, para poder seleccionarlo después en la ventana Usuarios.
        newPlanName: '', //Indica el nombre de un nuevo plan de estudios registrado, para poder seleccionarlo después en la ventana Planes de Estudios.
        newCourseName: '', //Indica el nombre de una nueva materia registrada.
        divisionNameToLookFor: '',
        newPaqueteName: '',

        selectedUserIndex: -1, //Indice del usuario seleccionado en la ventana Usuarios.
        selectedPlanIndex: -1, //Indice del plan de estudios seleccionado en la ventana PlanesEstudios.
        selectedCourseIndex: -1, //Indice de la materia seleccionada en la ventana PlannesEstdios.
        selectedDivisionIndex: -1,
        selectedPaqueteIndex: -1,

        planesEstudios: [],
        divisiones: [],
        paquetesPrograma: [],

        planEstudios: null, //Plan de estudios seleccionado en la ventana Planes de Estudios (del módulo de administración). También es el plan de estudios del alumno logueaedo.
        materiasPaquete: [], //Materias del paquete de estudios seleccionado en la ventana Planes de Estudios (del módulo de administración).
        materia: null, //Materia seleccionada del plan de estudios seleccionado (para el módulo de administración).
        noPrerreq: null, //Materia seleccionada de la lista de materias que no son prerrequisitos de una materia (seleccionable para ser prerrequisito).
        division: null,

        packageImg: null, //Imagen del paquete seleccionado.

        bPaquetesProgramaLoaded: false, //Idnica si ya se recibieron los paquetes del programa seleccionado.
        bMateriasPaqueteLoaded: false, //Indica si ya se recibieron las materias del paquete solicitado a la BD, para después poder obtener la información relacionada.
        bMateriaLoaded: false, //Indica si ya se recibió la materia solicitada a la BD, para después poder obtener la información relacionada.
        bNoPrerreqLoaded: false, //Indica si ya se recibió la materia solicitada a la BD.
        bLoadingData: false, //Indica si la información de la BD está siendo cargada, para no dejar cambiarse a ninguna otro plan o materia antes de que se reciba toda la información.

        bShowSequenceOptionsDlg: false, //Para desplegar el modal de la(s) opción(es) de una secuencia, en el módulo de alumnos.
        sequenceOptionID: 0, //ID de la opción a mostrar en el modal de opciones para las secuencias, en el módulo de alumnos.

        bCaptchaOK: false,
        bSubmittingRecaptcha: false,

        bShowAOCsByPackage: '1',
        catalogoAOCs: [],
        userAOCs: [],

        bShowPackageInfoDlg: false,
        materiasPaqueteAlumno: [], //Materias de un paquete para el módulo de alumnos.

        bForceRedraw: false, //Indica a la vista si hay que redibujarse.

        bMyAOCsDlg: false,
        bShowHeader: false,
    },

    mutations: {
        setFailedLogin(state, payload) {
            state.bFailedLogin = payload;
        },
        setInactiveUser(state, payload) {
            state.bInactiveUser = payload;
        },
        authUser(state, userData) {
            //state.authHeader = userData.authHeader;
            state.idToken = userData.idToken;
            state.userID = userData.userID;
        },
        clearAuthData(state) {
            //state.authHeader = null,
            //console.log('clearAuthData...');

            state.idToken = null;
            state.userID = null;
            state.isAuthenticated = false;
        },
        setDuplicatedUserError(state, payload) {
            state.bDuplicatedUserError = payload;
        },
        setIsAuthenticated(state, payload) {
            state.isAuthenticated = payload;
        },
        setUser(state, user) {
            state.user = user;
            state.userName = user.nombre;
            if (user.apPaterno !== '') {
                state.userName += ' ' + user.apPaterno;
            }
            if (user.apMaterno !== '') {
                state.userName += ' ' + user.apMaterno;
            }
            state.user.carrera = user.carrera;
            state.numCuenta = user.numCuenta;
            state.periodoInicioID = user.periodoInicioID;
            state.anioInicio = user.anioInicio;
            //state.semestre = user.semestre;
            state.planID = user.planid;

            if (state.user.tipoid === 1) {
                //Administrador
                state.bAdmin = true;
            } //Alumno
            else {
                state.bAdmin = false;
            }
        },

        setPeriodoInicioID(state, payload) {
            state.periodoInicioID = payload;
        },

        setAnioInicio(state, payload) {
            state.anioInicio = payload;
        },

        setPaquetesProgramaLoaded(state, bLoaded) {
            state.bPaquetesProgramaLoaded = bLoaded;
        },

        setMateriasPaqueteLoaded(state, bLoaded) {
            state.bMateriasPaqueteLoaded = bLoaded;
        },

        setMateriaLoaded(state, bLoaded) {
            state.bMateriaLoaded = bLoaded;
        },

        setNoPrerreqLoaded(state, bLoaded) {
            state.bNoPrerreqLoaded = bLoaded;
        },

        setLoadingData(state, bLoading) {
            state.bLoadingData = bLoading;
        },

        setUserTypes(state, userTypes) {
            state.bWaitCursor = true;
            state.userTypes = userTypes;
            state.bWaitCursor = false;
        },

        setServerResponse(state, bResponse) {
            state.bServerResponse = bResponse;
        },

        setSemestres(state, semestres) {
            state.bWaitCursor = true;
            state.semestres = semestres;
            state.bWaitCursor = false;

            //console.log('state.semestres = ', state.semestres);
        },

        setUsers(state, users) {
            if (state.users !== null) {
                state.users.length = 0;
            }

            state.bWaitCursor = true;
            state.users = users;

            var i;
            for (i = 0; i < users.length; i++) {
                // const user = {
                //     name: users[i].apaterno + " " + users[i].amaterno + " " + users[i].nombre,
                //     id: users[i].usuariosid
                // };

                if (state.bSearchNewUser) {
                    if (state.newUserEmail === users[i].email) {
                        //console.log("Nuevo usuario identificado, ", users[i].email);
                        state.selectedUserIndex = i;
                        state.bSearchNewUser = false;
                        state.newUserEmail = '';
                        break;
                    }
                }
            }
            state.bWaitCursor = false;
        },
        setAdministrators(state, users) {
            if (state.administrators !== null) {
                state.administrators.length = 0;
            }

            state.bWaitCursor = true;
            state.administrators = users;

            var i;
            for (i = 0; i < users.length; i++) {
                // const user = {
                //     name: users[i].apaterno + " " + users[i].amaterno + " " + users[i].nombre,
                //     id: users[i].usuariosid
                // };

                if (state.bSearchNewUser) {
                    if (state.newUserEmail === users[i].correo) {
                        //console.log("Nuevo usuario identificado, ", users[i].email);
                        state.selectedUserIndex = i;
                        state.bSearchNewUser = false;
                        state.newUserEmail = '';
                    }
                }
            }
            state.bWaitCursor = false;
        },
        addNewUser(state, newUser) {
            state.users.push(newUser);
        },
        addNewAdministrator(state, newUser) {
            state.administrators.push(newUser);
        },
        updateSelectedUserIndex: (state, index) => {
            state.selectedUserIndex = index;
        },

        updateSelectedPlanIndex: (state, index) => {
            state.selectedPlanIndex = index;
        },

        updateSelectedCourseIndex: (state, index) => {
            state.selectedCourseIndex = index;
        },

        updateSelectedDivisionIndex: (state, index) => {
            state.selectedDivisionIndex = index;
        },

        updateSelectedPaqueteIndex: (state, index) => {
            state.selectedPaqueteIndex = index;
        },

        setPlanesEstudios(state, planes) {
            if (state.planesEstudios !== null) {
                state.planesEstudios.length = 0;
            }

            state.bWaitCursor = true;
            state.planesEstudios = planes;

            for (let i = 0; i < planes.length; i++) {
                if (state.bSearchNewPlanEstudios) {
                    if (state.newPlanName === planes[i].plan) {
                        state.selectedPlanIndex = i;
                        state.bSearchNewPlanEstudios = false;
                        state.newPlanName = '';
                        break;
                    }
                }
            }

            state.bWaitCursor = false;
        },

        setPlan(state, plan) {
            state.planEstudios = plan;
        },

        setPaquetesPrograma(state, paquetes) {
            state.bWaitCursor = true;
            state.paquetesPrograma = paquetes;

            for (let i = 0; i < paquetes.length; i++) {
                if (state.bSearchNewPaquete) {
                    if (state.newPaqueteName === paquetes[i].nombre) {
                        state.selectedPaqueteIndex = i;
                        state.bSearchNewPaquete = false;
                        state.newPaqueteName = '';
                        break;
                    }
                }
            }

            state.bWaitCursor = false;
        },

        setMateriasPaquete(state, materias) {
            state.bWaitCursor = true;
            state.materiasPaquete = materias;

            for (let i = 0; i < materias.length; i++) {
                if (state.bSearchNewCourse) {
                    if (state.newCourseName === materias[i].materia) {
                        state.selectedCourseIndex = i;
                        state.bSearchNewCourse = false;
                        state.newCourseName = '';
                        //console.log('selectedCourseIndex = ', state.selectedCourseIndex);
                        break;
                    }
                }
            }

            state.bWaitCursor = false;
        },

        setMateria(state, materia) {
            state.materia = materia;
        },

        setNoPrerreq(state, materia) {
            state.noPrerreq = materia;
        },

        setShowSequenceOptionsDlg(state, payload) {
            state.bShowSequenceOptionsDlg = payload;
        },

        setSequenceOptionID(state, payload) {
            state.sequenceOptionID = payload;
        },

        setMateriaID(state, payload) {
            state.materiaID = payload;
        },

        setCaptchaOK(state, payload) {
            state.bCaptchaOK = payload;
        },

        setSubmittingRecaptcha(state, payload) {
            state.bSubmittingRecaptcha = payload;
        },

        setDivisiones(state, divisiones) {
            if (state.divisiones !== null) {
                state.divisiones.length = 0;
            }

            state.bWaitCursor = true;
            state.divisiones = divisiones;
            state.bDivisionFound = false;

            for (let i = 0; i < divisiones.length; i++) {
                if (state.bSearchDivision) {
                    if (state.divisionNameToLookFor === divisiones[i].nombre) {
                        //console.log('divisionName found in setDivisiones...');
                        state.selectedDivisionIndex = i;
                        state.bSearchDivision = false;
                        state.bDivisionFound = true;
                        state.divisionNameToLookFor = '';
                        break;
                    }
                }
            }

            state.bWaitCursor = false;
        },

        setPackageImg(state, img) {
            state.packageImg = img;
        },

        setShowAOCsByPackate(state, payload) {
            state.bShowAOCsByPackage = payload;
        },

        setCatalogoAOCs(state, catalogo) {
            state.catalogoAOCs = catalogo;
        },

        setUserAOCs(state, userAOCs) {
            state.userAOCs = userAOCs;
        },

        setShowPackageInfoDlg(state, bShowDlg) {
            state.bShowPackageInfoDlg = bShowDlg;
        },

        setMyAOCsDlg(state, bShowDlg) {
            state.bMyAOCsDlg = bShowDlg;
        },

        setMateriasPaqueteAlumno(state, materias) {
            state.materiasPaqueteAlumno = materias;
        },

        setForceRedraw(state, payload) {
            state.bForceRedraw = payload;
        },

        setShowHeader(state, payload) {
            state.bShowHeader = payload;
        },
    },
    actions: {
        login({ commit, dispatch, state }, authData) {
            state.bWaitCursor = true;

            //Limpia la información:
            state.planID = 0;
            state.planEstudios = null;
            state.semestres = [];
            state.bAlumnoPrueba = false;
            state.numCuentaAlumnoPrueba = 0;

            dispatch('updateShowHeader', false);

            //Autenticación en Jocoque:
            axios
                .post('/usuarios/login/', null, {
                    params: {
                        user: authData.user,
                        password: authData.password,
                    },
                })
                .then((res) => {
                    state.bWaitCursor = false;
                    console.log('Autenticación OK, res = ', res);
                    //console.log('En Login, semestres = ', state.semestres);
                    //console.log('En login, planID = ', state.planID);
                    var user = res.data;
                    if (user.error === 0) {
                        var idToken = user.token.slice(7);

                        //Si el usuario es administrador, usuarioID será user.userid,
                        //si es alumno de prueba, usuarioID será el número de cuenta:
                        var userID = 0;
                        //Para forzar alumno de prueba:
                        //user.tipoid = 2; //QUITAR ESTA LÍNEA ******************************************************************
                        if (user.tipoid === 1) {
                            //Administrador
                            userID = user.usuarioid;
                        } else if (user.tipoid === 2) {
                            //Alumno de pruebas
                            state.bAlumnoPrueba = true;
                            //userID = user.numCuenta;
                            state.numCuentaAlumnoPrueba = user.numCuenta;
                            //userID = user.usuarioid;
                            userID = user.alumnoid;
                        }

                        commit('authUser', { idToken: idToken, userID: userID });
                        commit('setIsAuthenticated', true);

                        if (user.tipoid === 1) {
                            //Administrador:
                            dispatch('fetchAdminConfigData');
                            commit('setUser', user);
                            dispatch('updateShowHeader', true);
                        } else if (user.tipoid === 2) {
                            //Alumno:
                            state.user.nombre = user.nombre;
                            state.user.apPaterno = '';
                            state.user.apMaterno = '';
                            state.user.carrera = user.carrera;
                            state.user.tipoid = 2;
                            dispatch('fetchStudentConfigData', userID);
                            dispatch('updateShowHeader', false);
                        }

                        dispatch('setLogoutTimer', res.data.expiresin);

                        state.bWaitCursor = false;
                        router.push('/').catch((err) => {});
                    } else if (user.error === 3) {
                        //Usuario Inactivo...
                        state.bWaitCursor = false;
                        commit('setIsAuthenticated', false);
                        commit('setInactiveUser', true);
                    } //Error en nombre de usuario o password...
                    else {
                        //console.log('Error de autenticación #', user.error);
                        state.bWaitCursor = false;
                        //commit('clearAuthData');
                        commit('setIsAuthenticated', false);
                        commit('setFailedLogin', true);
                    }
                })
                .catch((error) => {
                    //console.log('Error de autenticación #0: ', error);
                    state.bWaitCursor = false;

                    //commit('clearAuthData');
                    commit('setIsAuthenticated', false);
                    commit('setFailedLogin', true);
                });
        },

        updateFailedLogin({ commit }, failedLogin) {
            commit('setFailedLogin', failedLogin);
        },

        updateInactiveUser({ commit }, inactiveUser) {
            commit('setInactiveUser', inactiveUser);
        },

        setLogoutTimer({ commit }, expirationTime) {
            setTimeout(() => {
                //console.log('Llamando a clearAuthData desde setLogoutTimer');
                commit('clearAuthData');
                router.replace('/sign-in'); //Aparentemente es mejor replace que push porque con replace el usuario no puede irse hacia atrás.
            }, expirationTime * 1000);
        },

        logout({ commit, state }) {
            axios.delete('/sesion/deleteSession/' + state.idToken); //Borra la sesión
            commit('clearAuthData');

            state.planID = 0;
            state.planEstudios = null;
            state.semestres = [];

            //router.replace('/sign-in');//Se supone que es mejor replace que push porque con replace el usuario no puede irse hacia atrás.
            router.replace('/sign-in').catch((err) => {}); //Se supone que es mejor replace que push porque con replace el usuario no puede irse hacia atrás.
        },

        studentLogin({ dispatch, commit, state }, studentInfo) {
            state.bWaitCursor = true;
            console.log('student Login, studentInfo = ', studentInfo);

            state.bAlumnoPrueba = false;
            state.user.numCuenta = studentInfo.numCuenta;
            state.user.carrera = studentInfo.carrera;

            axios
                .post('/usuarios/getStudentInfo/', studentInfo)
                .then((res) => {
                    console.log('getStudentInfo OK, res = ', res);
                    state.bWaitCursor = false;
                    var user = res.data;
                    if (user.error === 0) {
                        var idToken = user.token.slice(7);
                        user.tipoid = 2; //alumno
                        var userID = user.alumnoid;

                        commit('authUser', { idToken: idToken, userID: userID });
                        commit('setIsAuthenticated', true);
                        state.user.nombre = user.nombre;
                        state.user.apPaterno = '';
                        state.user.apMaterno = '';
                        state.user.tipoid = user.tipoid;
                        dispatch('fetchStudentConfigData', userID);
                        dispatch('setLogoutTimer', res.data.expiresin);

                        state.bWaitCursor = false;

                        dispatch('updateShowHeader', false);
                        router.push('/').catch((err) => {});
                    }
                })
                .catch((error) => {
                    console.log('Error de autenticación #0: ', error);
                    state.bWaitCursor = false;

                    commit('setIsAuthenticated', false);
                    commit('setFailedLogin', true);
                });
        },

        studentLogout({ dispatch, commit, state }) {
            if (state.bAlumnoPrueba) {
                dispatch('logout');
            } else {
                axios.delete('/sesion/deleteSession/' + state.idToken); //Borra la sesión
                commit('clearAuthData');
                state.planID = 0;
                state.planEstudios = null;
                state.semestres = [];

                router.replace('/re-enter').catch((err) => {}); //Se supone que es mejor replace que push porque con replace el usuario no puede irse hacia atrás.
            }
        },

        studentReEnter({ dispatch, state }) {
            const studentInfo = {
                numCuenta: state.user.numCuenta,
                carrera: state.user.carrera,
            };
            dispatch('studentLogin', studentInfo);
        },

        fetchAdminConfigData({ dispatch, state }) {
            if (!state.idToken) {
                return;
            }
            dispatch('fetchUserTypes');
            dispatch('fetchUsers');

            dispatch('fetchPlanesEstudios');
            dispatch('fetchDivisiones');
        },

        fetchStudentConfigData({ dispatch, state }) {
            if (!state.idToken) {
                return;
            }

            state.bWaitCursor = true;

            //Se obtienen todos los planes de estudios, para saber la fecha de inicio de cada plan y poder
            //asignarle el plan correspondiente al alumno en caso de que el alumno configure su primer semestre:
            //dispatch('fetchPlanesEstudios');  NO CREO QUE SEA NECESARIO LLAMAR A ESTO PARA UN ALUMNO.

            axios
                .get('alumnos/getMateriasPaquetes/' + state.userID + '/' + state.idToken, {
                    crossDomain: true,
                })
                .then((res) => {
                    state.bWaitCursor = false;
                    //console.log('res de alumnos/getMateriasPaquetes: ', res);
                    const userAOCs = res.data;
                    dispatch('updateUserAOCs', userAOCs);
                    dispatch('fetchCatalogoPorPaquete');
                })
                .catch((error) => {
                    state.bWaitCursor = false;
                });

            //Inicio pruebas:
            /*const userAOCs = {
                materias: [
                    {
                        materiaid: 1,
                    },
                    {
                        materiaid: 2,
                    },
                    {
                        materiaid: 3,
                    },
                ],
                paquetes: [
                    {
                        paqueteid: 1,
                    },
                    {
                        paqueteid: 3,
                    },
                ],
            };
            dispatch('updateUserAOCs', userAOCs);
            dispatch('fetchCatalogoPorPaquete');*/
            //Fin pruebas.
        },

        updateUserAOCs({ commit }, userAOCs) {
            commit('setUserAOCs', userAOCs);
        },

        selectPackage({ commit, dispatch, state }, packageID) {
            state.bWaitCursor = false;
            axios
                .get('/alumnos/agregaPaquete/' + state.userID + '/' + packageID + '/' + state.idToken, {
                    crossDomain: true,
                })
                .then((res) => {
                    //console.log('selectPackage, res = ', res);
                    const userAOCs = res.data;
                    dispatch('updateUserAOCs', userAOCs);
                    //dispatch('initCatalogoPaquetes'); Creo que no es necesario, porque esto se actualiza en Home.vue
                    state.bWaitCursor = false;
                })
                .catch((error) => {
                    //console.log('Error en selectPackage: ' + error);
                    state.bWaitCursor = false;
                });
        },

        unselectPackage({ commit, dispatch, state }, packageID) {
            state.bWaitCursor = true;

            axios
                .get('/alumnos/borraPaquete/' + state.userID + '/' + packageID + '/' + state.idToken, {
                    crossDomain: true,
                })
                .then((res) => {
                    //console.log('unselectPackage, res = ', res);
                    const userAOCs = res.data;
                    dispatch('updateUserAOCs', userAOCs);
                    state.bWaitCursor = false;
                    //dispatch('initCatalogoPaquetes'); //Creo que esto no es necesario, porque esto se actualiza en Home.vue
                })
                .catch((error) => {
                    //console.log('Error en unselectPackage: ' + error);
                    state.bWaitCursor = false;
                });
        },

        selectCourse({ commit, dispatch, state }, courseID) {
            state.bWaitCursor = false;
            axios
                .get('/alumnos/agregaMateria/' + state.userID + '/' + courseID + '/' + state.idToken, {
                    crossDomain: true,
                })
                .then((res) => {
                    //console.log('selectCourse, res = ', res);
                    const userAOCs = res.data;
                    dispatch('updateUserAOCs', userAOCs);
                    //dispatch('initCatalogoPaquetes'); Creo que no es necesario, porque esto se actualiza en Home.vue
                    state.bWaitCursor = false;
                })
                .catch((error) => {
                    //console.log('Error en selectCourse: ' + error);
                    state.bWaitCursor = false;
                });
        },

        unselectCourse({ commit, dispatch, state }, courseID) {
            state.bWaitCursor = true;

            axios
                .get('/alumnos/borraMateria/' + state.userID + '/' + courseID + '/' + state.idToken, {
                    crossDomain: true,
                })
                .then((res) => {
                    //console.log('unselectPackage, res = ', res);
                    const userAOCs = res.data;
                    dispatch('updateUserAOCs', userAOCs);
                    state.bWaitCursor = false;
                    //dispatch('initCatalogoPaquetes'); //Creo que esto no es necesario, porque esto se actualiza en Home.vue
                })
                .catch((error) => {
                    //console.log('Error en unselectCourse: ' + error);
                    state.bWaitCursor = false;
                });
        },

        fetchCatalogoPorPaquete({ commit, dispatch, state }) {
            state.bWaitCursor = true;

            const planID = 1; //Pendiente: Checar de dónde se va obtener el plan de estudios del alumno.

            axios
                .get('/paquetes/getPaquetesByPlan/' + planID + '/' + state.idToken, {
                    crossDomain: true,
                })
                .then((res) => {
                    //console.log('fetchCatalogoAOCs, res = ', res);
                    const catalogo = res.data;
                    if (catalogo !== 0) {
                        dispatch('updateCatalogoAOCs', catalogo);
                        //Selecciona en el catálogo los paquetes seleccionados por el usuario y checa si en cada división hay paquetes:
                        dispatch('initCatalogoPaquetes');

                        /*for (let i = 0; i < state.catalogoAOCs.length; i++) {
                            for (let j = 0; j < state.catalogoAOCs[i].departamentos.length; j++) {
                                for (let k = 0; k < state.catalogoAOCs[i].departamentos[j].paquetes.length; k++) {
                                    if (state.catalogoAOCs[i].departamentos[j].paquetes[k].logoInfo.id) {
                                        var imgInfo = {
                                            photoInfo: state.catalogoAOCs[i].departamentos[j].paquetes[k].logoInfo,
                                            paqueteid: state.catalogoAOCs[i].departamentos[j].paquetes[k].paqueteid,
                                            departamentoid: state.catalogoAOCs[i].departamentos[j].departamentoid,
                                        };

                                        state.bForceRedraw = false;
                                        dispatch('getFotoPaqueteAlumnos', imgInfo);
                                    }
                                }
                            }
                        }*/
                    }
                    state.bWaitCursor = false;
                })
                .catch((error) => {
                    //console.log('Error en fetchCatalogoAOCs, error = ', error);
                    state.bWaitCursor = false;
                });

            //Inicio pruebas:

            /*const catalogo = [
                {
                    divisionid: 1,
                    nombre: 'División de Ciencia, Arte y Tecnología',
                    sigla: 'DiCAT',
                    departamentos: [
                        {
                            departamentoid: 1,
                            nombre: 'Arquitectura, Urbanismo e Ingeniería Civil',
                            paquetes: [
                                {
                                    paqueteid: 1,
                                    nombre: 'Transformación urbana, patrimonio cultural y sustentabilidad',
                                    descripcion:
                                        'En este paquete relacionarás las dinámicas de transformación urbana, la construcción de identidades y la conservación del patrimonio cultural en el marco del desarrollo urbano sustentable.',
                                    foto: require('@/assets/no-photo.png'),
                                    seleccionado: false,
                                },
                                {
                                    paqueteid: 2,
                                    nombre: 'Infraestructura, sociedad y sustentabilidad',
                                    descripcion:
                                        'En este paquete identificarás el ipacto que tienen las soluciones de nfraestructura en el bienestar social, económico y ambiental de las comunidades, desde los enfoques local, nacional y global.',
                                    foto: require('@/assets/no-photo.png'),
                                    seleccionado: false,
                                },
                            ],
                        },
                        {
                            departamentoid: 2,
                            nombre: 'CENTRUS',
                            paquetes: [
                                {
                                    paqueteid: 3,
                                    nombre: 'Sustentabilidad y empresas',
                                    descripcion:
                                        'En este paquete utilizarás herramientas de análisis y metodologías para el apoyo al proceso de sustentabilidad en el sector empresarial.',
                                    foto: require('@/assets/no-photo.png'),
                                    seleccionado: false,
                                },
                                {
                                    paqueteid: 4,
                                    nombre: 'Educación y comunicación para la sustentabilidad',
                                    descripcion:
                                        'En este paquete diseñarás estrategias y productos de comunicación y educación ambiental para promover el cambio social hacia la sustentabilidad.',
                                    foto: require('@/assets/no-photo.png'),
                                    seleccionado: false,
                                },
                            ],
                        },
                    ],
                },
                {
                    divisionid: 2,
                    nombre: 'División de Estudios Sociales',
                    sigla: 'DES',
                    departamentos: [
                        {
                            departamentoid: 3,
                            nombre: 'Ciencias Sociales y Políticas',
                            paquetes: [
                                {
                                    paqueteid: 5,
                                    nombre: 'Prospectiva y análisis político',
                                    descripcion:
                                        'En este paquete aprenderás a implementar herramientas de la Ciencia Política para el análisis de procesos coyunturales y el diseño de estrategias políticas que permitan tomar decisiones en asuntos públicos, de la iniciativa privada, del sector social y el ámbito global.',
                                    foto: require('@/assets/no-photo.png'),
                                    seleccionado: false,
                                },
                            ],
                        },
                    ],
                },
            ];

            dispatch('updateCatalogoAOCs', catalogo);
            //Selecciona en el catálogo los paquetes seleccionados por el usuario:
            dispatch('initCatalogoPaquetes');
            */
            //Fin pruebas.
        },

        initCatalogoPaquetes({ dispatch, state }) {
            //Desselecciona todos los paquetes y verifica que el paquete sólo venga una vez en cada división:

            for (let i = 0; i < state.catalogoAOCs.length; i++) {
                var paquetesDivision = [];
                //console.log('Division: ', state.catalogoAOCs[i].nombre);
                for (let j = 0; j < state.catalogoAOCs[i].departamentos.length; j++) {
                    for (let k = 0; k < state.catalogoAOCs[i].departamentos[j].paquetes.length; k++) {
                        //console.log('paqueteid = ', state.catalogoAOCs[i].departamentos[j].paquetes[k].paqueteid);
                        //console.log('paquetesDivision = ', paquetesDivision);
                        var bPaqueteEncontrado = false;
                        for (let l = 0; l < paquetesDivision.length; l++) {
                            //Checa si el paquete ya estaba registrado antes en la misma división:
                            if (paquetesDivision[l] === state.catalogoAOCs[i].departamentos[j].paquetes[k].paqueteid) {
                                bPaqueteEncontrado = true;

                                //console.log('Paquete encontrado...');
                                //console.log('paquetesDivision = ', paquetesDivision);
                                //console.log('paqueteID = ', state.catalogoAOCs[i].departamentos[j].paquetes[k].paqueteid);
                                break;
                            }
                        }
                        if (!bPaqueteEncontrado) {
                            state.catalogoAOCs[i].departamentos[j].paquetes[k].seleccionado = false;
                            paquetesDivision.push(state.catalogoAOCs[i].departamentos[j].paquetes[k].paqueteid);
                        } else {
                            state.catalogoAOCs[i].departamentos[j].paquetes.splice(k, 1);
                            k--;
                        }

                        //console.log('Al final de esta división, paquetesDivision = ', paquetesDivision);
                    }
                }
            }

            //Selecciona los paquetes seleccionados por el usuario:
            for (let i = 0; i < state.userAOCs.paquetes.length; i++) {
                var bPaqueteEncontrado = false;
                for (let j = 0; j < state.catalogoAOCs.length; j++) {
                    for (let k = 0; k < state.catalogoAOCs[j].departamentos.length; k++) {
                        for (let l = 0; l < state.catalogoAOCs[j].departamentos[k].paquetes.length; l++) {
                            if (state.userAOCs.paquetes[i].paqueteid === state.catalogoAOCs[j].departamentos[k].paquetes[l].paqueteid) {
                                state.catalogoAOCs[j].departamentos[k].paquetes[l].seleccionado = true;
                                bPaqueteEncontrado = true;
                                break;
                            }
                        }
                        /*if (bPaqueteEncontrado) {
                            break;
                        }*/
                    }
                    //Se comenta el siguiente bloque para que se pueda seleccionar el paquete si también es ofrecido
                    //por otra división:
                    /*if (bPaqueteEncontrado) {
                        break;
                    }*/
                }
            }

            //Cuenta los paquetes que tiene cada división, para saber si se despliega la división o no en Home.vue, creando
            //el campo numpaquetes:
            for (let i = 0; i < state.catalogoAOCs.length; i++) {
                var numPaquetes = 0;
                for (let j = 0; j < state.catalogoAOCs[i].departamentos.length; j++) {
                    numPaquetes += state.catalogoAOCs[i].departamentos[j].paquetes.length;
                }
                state.catalogoAOCs[i].numPaquetes = numPaquetes;
            }

            //Obtiene las fotos de los paquetes:
            for (let i = 0; i < state.catalogoAOCs.length; i++) {
                for (let j = 0; j < state.catalogoAOCs[i].departamentos.length; j++) {
                    for (let k = 0; k < state.catalogoAOCs[i].departamentos[j].paquetes.length; k++) {
                        if (state.catalogoAOCs[i].departamentos[j].paquetes[k].logoInfo.id) {
                            var imgInfo = {
                                photoInfo: state.catalogoAOCs[i].departamentos[j].paquetes[k].logoInfo,
                                paqueteid: state.catalogoAOCs[i].departamentos[j].paquetes[k].paqueteid,
                                departamentoid: state.catalogoAOCs[i].departamentos[j].departamentoid,
                            };

                            state.bForceRedraw = false;
                            //console.log('Llamando a getFotoPaqueteAlumnos con imgInfo = ', imgInfo);
                            dispatch('getFotoPaqueteAlumnos', imgInfo);
                        }
                    }
                }
            }

            //console.log('Después de las fotos, catalogoAOCs = ', state.catalogoAOCs);
        },

        fetchCatalogoPorAsignatura({ commit, dispatch, state }) {
            state.bWaitCursor = true;

            const planID = 1; //Pendiente: checar de dónde va a salir este dato.

            axios
                .get('/paquetes/getPaquetesByAsignatura/' + planID + '/' + state.idToken, {
                    crossDomain: true,
                })
                .then((res) => {
                    //console.log('fetchCatalogoPorAsignatura, res = ', res);
                    const catalogo = res.data;
                    if (catalogo !== 0) {
                        dispatch('updateCatalogoAOCs', catalogo);
                        //Selecciona en el catálogo las materias seleccionadas por el usuario:
                        dispatch('initCatalogoAsignaturas');
                    }
                    state.bWaitCursor = false;
                })
                .catch((error) => {
                    //console.log('Error en fetchCatalogoAOCs, error = ', error);
                    state.bWaitCursor = false;
                });

            //Inicio pruebas:

            /*const catalogo = [
                {
                    divisionid: 1,
                    nombre: 'División de Ciencia, Arte y Tecnología',
                    sigla: 'DiCAT',
                    departamentos: [
                        {
                            departamentoid: 1,
                            nombre: 'Arquitectura, Urbanismo e Ingeniería Civil',
                            materias: [
                                {
                                    materiaid: 1,
                                    clave: '80113',
                                    nombre: 'Gestión de la ciudad heredada',
                                    descripcion:
                                        'En esta materia relacionarás los valores existentes en la ciudad heredada con el bienestar socioambiental y la construcción de identidades locales en el marco del desarrollo sustentable.',
                                    prerrequisitos: [],
                                    paquete:
                                        'Transformación urbana, patrimonio cultural y sustentabilidad',
                                    seleccionada: false,
                                },
                                {
                                    materiaid: 2,
                                    clave: '80112',
                                    nombre: 'Ciudad de México: morfología y transformación',
                                    descripcion:
                                        'En esta materia analizarás la relación entre la forma urbana de las distintas etapas cronológicas de los asentamientos humanos en el Valle de México y las transformaciones geográficas, socioeconómicas, culturales y políticas de su entorno, como insumo para comprender su situación actual.',
                                    prerrequisitos: [],
                                    paquete:
                                        'Transformación urbana, patrimonio cultural y sustentabilidad',
                                    seleccionada: false,
                                },
                                {
                                    materiaid: 3,
                                    clave: '24819',
                                    nombre: 'El patrimonio edificado en la actuaidad',
                                    descripcion:
                                        'En esta materia relacionarás la evoluci´n de la disciplina de la conservación del patrimonio edificado con las teorías de intervanción y restauración arquitectónica.',
                                    prerrequisitos: [],
                                    paquete:
                                        'Transformación urbana, patrimonio cultural y sustentabilidad',
                                    seleccionada: false,
                                },
                                {
                                    materiaid: 4,
                                    clave: '24469',
                                    nombre: 'Impacto y respuesta ante desastres naturales',
                                    descripcion:
                                        'En esta materia identificarás los tipos de desastres naturales típicos en diferentes regiones del mundo, la terminología que se emplea para describirlos y estudiarlos, y los tipos de desastres que se tienen comúnmente en México.',
                                    prerrequisitos: [],
                                    paquete: 'Infraestructura, sociedad y sustentabilidad',
                                    seleccionada: false,
                                },
                            ],
                        },
                        {
                            departamentoid: 2,
                            nombre: 'CENTRUS',
                            materias: [
                                {
                                    materiaid: 5,
                                    clave: '23448',
                                    nombre: 'Diseño de futuros sustentables',
                                    descripcion:
                                        'En esta materia adquirirás conocimientos, metodologías y herramientas para incorporar análisis de patrones, tendencias y escenarios para el diseño de futuros sustentables.',
                                    prerrequisitos: [],
                                    paquete: 'Sustentabilidad y empresas',
                                    seleccionada: false,
                                },
                                {
                                    materiaid: 6,
                                    clave: '23452',
                                    nombre: 'Sustentabilidad en el ámbito empresarial',
                                    descripcion:
                                        'En esta materia desarrollarás capacidades para la definición y evaluación de estrategias empresariales integrales que protejan el medio ambiente.',
                                    prerrequisitos: [],
                                    paquete: 'Sustentabilidad y empresas',
                                    seleccionada: false,
                                },
                                {
                                    materiaid: 7,
                                    clave: '23449',
                                    nombre: 'Certificación en sustentabilidad',
                                    descripcion:
                                        'En esta materia ejecutarás una metodología para el logro de certificaciones de sustentabilidad a partir de su planeación y para el apyo del proceso de sustentabilidad en diferentes sectores económicos.',
                                    prerrequisitos: [],
                                    paquete: 'Sustentabilidad y empresas',
                                    seleccionada: false,
                                },
                            ],
                        },
                    ],
                },
                {
                    divisionid: 2,
                    nombre: 'División de Estudios Sociales',
                    sigla: 'DES',
                    departamentos: [
                        {
                            departamentoid: 3,
                            nombre: 'Ciencias Sociales y Políticas',
                            materias: [
                                {
                                    materiaid: 8,
                                    clave: '24066',
                                    nombre: 'Análisis político de coyuntura',
                                    descripcion:
                                        'En esta materia reconocerás fenómenos políticos que pueden transformarse en fenómenos políticos de coyuntura, con el uso de herramientas teóricas y metodológicas.',
                                    prerrequisitos: [],
                                    paquete: 'Perspectiva y análisis político',
                                    seleccionada: false,
                                },
                            ],
                        },
                    ],
                },
            ];

            dispatch('updateCatalogoAOCs', catalogo);
            dispatch('initCatalogoAsignaturas');*/

            //Fin pruebas.
        },

        initCatalogoAsignaturas({ state }) {
            //Desselecciona todas las materias:
            /*for (let i = 0; i < state.catalogoAOCs.length; i++) {
                //Pone un campo show = false:
                state.catalogoAOCs[i].show = false;
                for (let j = 0; j < state.catalogoAOCs[i].departamentos.length; j++) {
                    for (let k = 0; k < state.catalogoAOCs[i].departamentos[j].materias.length; k++) {
                        state.catalogoAOCs[i].departamentos[j].materias[k].seleccionada = false;
                    }
                }
            }*/

            //Desselecciona todas las materias y verifica que la materia sólo venga una vez en cada departamento:
            for (let i = 0; i < state.catalogoAOCs.length; i++) {
                //Se crea un campo show = false:
                state.catalogoAOCs[i].show = false;
                for (let j = 0; j < state.catalogoAOCs[i].departamentos.length; j++) {
                    var materiasDepartmento = [];
                    for (let k = 0; k < state.catalogoAOCs[i].departamentos[j].materias.length; k++) {
                        var bMateriaEncontrada = false;
                        for (let l = 0; l < materiasDepartmento.length; l++) {
                            if (materiasDepartmento[l] === state.catalogoAOCs[i].departamentos[j].materias[k].materiaid) {
                                bMateriaEncontrada = true;
                                break;
                            }
                        }
                        if (!bMateriaEncontrada) {
                            state.catalogoAOCs[i].departamentos[j].materias[k].seleccionada = false;
                            materiasDepartmento.push(state.catalogoAOCs[i].departamentos[j].materias[k].materiaid);
                        } else {
                            state.catalogoAOCs[i].departamentos[j].materias.splice(k, 1);
                            k--;
                        }
                    }
                }
            }

            //Selecciona las materias seleccionadas por el usuario:
            for (let i = 0; i < state.userAOCs.materias.length; i++) {
                var bMateriaEncontrada = false;
                for (let j = 0; j < state.catalogoAOCs.length; j++) {
                    for (let k = 0; k < state.catalogoAOCs[j].departamentos.length; k++) {
                        for (let l = 0; l < state.catalogoAOCs[j].departamentos[k].materias.length; l++) {
                            if (state.userAOCs.materias[i].materiaid === state.catalogoAOCs[j].departamentos[k].materias[l].materiaid) {
                                state.catalogoAOCs[j].departamentos[k].materias[l].seleccionada = true;
                                bMateriaEncontrada = true;
                                break;
                            }
                        }
                        if (bMateriaEncontrada) {
                            break;
                        }
                    }
                    if (bMateriaEncontrada) {
                        break;
                    }
                }
            }

            //Cuenta las materias que tiene cada división, para saber si se despliega la división o no en Home.vue, creando
            //el campo numMaterias:
            for (let i = 0; i < state.catalogoAOCs.length; i++) {
                var numMaterias = 0;
                for (let j = 0; j < state.catalogoAOCs[i].departamentos.length; j++) {
                    numMaterias += state.catalogoAOCs[i].departamentos[j].materias.length;
                }
                state.catalogoAOCs[i].numMaterias = numMaterias;
            }
            //console.log('catalogoAOCs = ', state.catalogoAOCs);
        },

        updateCatalogoAOCs({ commit, state }, catalogo) {
            if (!state.idToken) {
                return;
            }
            commit('setCatalogoAOCs', catalogo);
        },

        updateShowAOCsByPackage({ commit }, payload) {
            commit('setShowAOCsByPackate', payload);
        },

        updatePeriodoInicioID({ commit, state }, periodoID) {
            if (!state.idToken) {
                return;
            }
            commit('setPeriodoInicioID', periodoID);
        },

        updateAnioInicio({ commit, state }, anio) {
            if (!state.idToken) {
                return;
            }
            commit('setAnioInicio', anio);
        },

        updateSemestres({ commit, state }, semestres) {
            if (!state.idToken) {
                return;
            }

            commit('setSemestres', semestres);
        },

        fetchUserTypes({ commit, state }) {
            state.bWaitCursor = true;

            axios
                .get('/tiposUsuario/getTiposUsuario/' + state.idToken, { crossDomain: true })
                .then((res) => {
                    //console.log('FetchUserTypes, res = ', res);
                    const userTypes = res.data;
                    state.bWaitCursor = false;
                    commit('setUserTypes', userTypes);
                })
                .catch((error) => {
                    //console.log('Error en fetchUserTypes, error = ', error);
                    state.bWaitCursor = false;
                });
        },

        fetchPlanesEstudios({ commit, state }) {
            state.bWaitCursor = true;

            //Pendiente: Los planes de estudios deben venir ordenados por fecha de inicio (de mayor a menor):
            axios
                .get('/planes/' + state.idToken, { crossDomain: true })
                .then((res) => {
                    //console.log('fetchPlanesEstudios, res = ', res);
                    const planes = res.data;
                    state.bWaitCursor = false;
                    commit('setPlanesEstudios', planes);
                })
                .catch((error) => {
                    //console.log('Error en fetchPlanesEstudios, error = ', error);
                    state.bWaitCursor = false;
                });
        },

        getPlanData({ dispatch, state }, planID) {
            state.bWaitCursor = true;

            /*axios
                .get('/planes/getById/' + planID + '/' + state.idToken, {
                    crossDomain: true,
                })
                .then((res) => {
                    //console.log('getPlanData, res = ', res);
                    const plan = res.data;
                    if (plan.planid !== 0) {
                        //console.log('getPlanData, plan = ', plan);
                        dispatch('updatePlan', plan);
                    }

                    state.bWaitCursor = false;
                })
                .catch((error) => {
                    //console.log('Error en getPlanData, error = ', error);
                    state.bWaitCursor = false;
                });*/

            //Inicio pruebas:
            var plan = {
                planid: 1,
                nombrePlan: 'Manresa',
                anioInicio: 2021,
                periodoInicioID: 3, //Otoño
            };

            dispatch('updatePlan', plan);
            state.bWaitCursor = false;

            //Fin pruebas.
        },

        fetchPaquetesPrograma({ dispatch, state }, packagesInfo) {
            state.bWaitCursor = true;

            state.bPaquetesProgramaLoaded = false;

            axios
                .get('/programasPaquetes/getPaquetesbyPrograma/' + packagesInfo.programaid + '/' + packagesInfo.planid + '/' + state.idToken, {
                    crossDomain: true,
                })
                .then((res) => {
                    //console.log('fetchPaquetesPrograma, res = ', res);
                    const paquetes = res.data;
                    if (paquetes !== 0) {
                        dispatch('updatePaquetesPrograma', paquetes);
                    }

                    state.bWaitCursor = false;
                })
                .catch((error) => {
                    //console.log('Error en fetchPaquetesPrograma, error = ', error);
                    state.bWaitCursor = false;
                });

            //Inicio pruebas:
            /*
            const paquetes = [
                {
                    paqueteid: 1,
                    divisionid: 1,
                    departamentoid: 1,
                    nombre: 'Mercado y procesos de producción del arte',
                    fotoInfo: {
                        id: null,
                    },
                    descripcion:
                        'En este paquete el alumno desarrollará proyectos de gestión cultural independientes o en el marco de alguna instancia pública o privada, con base en la elaboraciónde una propuesta que considere aspectos de planeación, gestión, administración y producción del reconocimiento del papel que desempeña el mercado del arte.',
                    notas: 'Notas de este paquete',
                    programas: [
                        {
                            programaid: 1,
                            nombre: 'Historia del Arte',
                            permitir: false,
                        },
                        {
                            programaid: 2,
                            nombre: 'Ciencias Teológicas',
                            permitir: true,
                        },
                    ],
                },
                {
                    paqueteid: 2,
                    divisionid: 1,
                    departamentoid: 1,
                    nombre: 'Estudios Visuales',
                    fotoInfo: {
                        id: null,
                    },
                    descripcion:
                        'Con este paquete el lumno interpretará la cultura de manera crítica y creativa, a partir del análisis de todo tipo de imágenes con base en elementos compositivos, así como de la teoría visual antropológica, desde las perspectivas de género, interculturalidad y sustentabilidad, para la comprensión de los supuestos...',
                    notas: 'Ninguna',
                    programas: [
                        {
                            programaid: 1,
                            nombre: 'Historia del Arte',
                            permitir: false,
                        },
                    ],
                },
            ];

            dispatch('updatePaquetesPrograma', paquetes);
            */
            //Fin pruebas
        },

        updatePaquetesPrograma({ commit, state }, paquetes) {
            commit('setPaquetesPrograma', paquetes);
            state.bPaquetesProgramaLoaded = true;
        },

        async getFotoPaquete({ commit, state }, imgInfo) {
            if (!state.idToken) {
                return;
            }
            state.bWaitCursor = true;

            axios
                .get('/downloadFile/' + imgInfo.id + '/' + state.idToken, {
                    crossDomain: true,
                    responseType: 'blob',
                })
                .then((res) => {
                    //console.log('getFotoPaquete, res = ', res);
                    state.bWaitCursor = false;
                    let imgFile = new File([res.data], imgInfo.fileName, {
                        type: imgInfo.fileType,
                    });
                    var logoFileURL = URL.createObjectURL(imgFile);

                    commit('setPackageImg', logoFileURL);
                })
                .catch((error) => {
                    //console.log('Error en getFotoPaquete, error = ', error);
                    let logoFileURL = require('@/assets/no-photo.png');
                    commit('setPackageImg', logoFileURL);
                    state.bWaitCursor = false;
                });
        },

        async getFotoPaqueteAlumnos({ commit, state }, imgInfo) {
            if (!state.idToken) {
                return;
            }
            state.bWaitCursor = true;

            axios
                .get('/downloadFile/' + imgInfo.photoInfo.id + '/' + state.idToken, {
                    crossDomain: true,
                    responseType: 'blob',
                })
                .then((res) => {
                    //console.log('getFotoPaqueteAlumnos, res = ', res);
                    state.bWaitCursor = false;
                    let imgFile = new File([res.data], imgInfo.photoInfo.fileName, {
                        type: imgInfo.photoInfo.fileType,
                    });
                    var logoFileURL = URL.createObjectURL(imgFile);

                    var bPackageFound = false;

                    for (let i = 0; i < state.catalogoAOCs.length; i++) {
                        for (let j = 0; j < state.catalogoAOCs[i].departamentos.length; j++) {
                            for (let k = 0; k < state.catalogoAOCs[i].departamentos[j].paquetes.length; k++) {
                                if (
                                    state.catalogoAOCs[i].departamentos[j].paquetes[k].paqueteid === imgInfo.paqueteid &&
                                    state.catalogoAOCs[i].departamentos[j].departamentoid === imgInfo.departamentoid
                                ) {
                                    state.catalogoAOCs[i].departamentos[j].paquetes[k].logoFileURL = logoFileURL;
                                    bPackageFound = true;
                                    state.bForceRedraw = true;
                                    break;
                                }
                            }
                            if (bPackageFound) {
                                break;
                            }
                        }
                        if (bPackageFound) {
                            break;
                        }
                    }

                    if (imgInfo.lastPhoto) {
                        state.bForceRedraw = true;
                    }
                })
                .catch((error) => {
                    //console.log('Error en getFotoPaquete, error = ', error);
                    let logoFileURL = require('@/assets/no-photo.png');
                    commit('setPackageImg', logoFileURL);
                    state.bWaitCursor = false;
                });
        },

        updatePackageImg({ commit, state }, img) {
            if (!state.idToken) {
                return;
            }
            commit('setPackageImg', img);
        },

        fetchMateriasPaquete({ dispatch, state }, packageID) {
            state.bWaitCursor = true;

            axios
                .get('/materias/getByPaqueteId/' + packageID + '/' + state.idToken, {
                    crossDomain: true,
                })
                .then((res) => {
                    //console.log('fetchMateriasPaquete, res = ', res);
                    const materias = res.data;
                    if (materias !== 0) {
                        dispatch('updateMateriasPaquete', materias);
                    }

                    state.bWaitCursor = false;
                })
                .catch((error) => {
                    //console.log('Error en fetchMateriasPaquete, error = ', error);
                    state.bWaitCursor = false;
                });

            //Inicio pruebas:
            /*var materias = [
                {
                    materiaid: 1,
                    materia: 'Gestión Cultural',
                    clave: '22377',
                },
                {
                    materiaid: 2,
                    materia: 'Mercado del arte',
                    clave: '1380',
                },
                {
                    materiaid: 3,
                    materia: 'Producción de exposiciones y gesitón de colecciones',
                    clave: '24659',
                },
            ];
            this.dispatch('updateMateriasPaquete', materias);
            */
            //Fin pruebas.
        },

        saveNewPackage({ dispatch, state }, packageToSave) {
            if (!state.idToken) {
                return;
            }
            //console.log('Package to save: ', packageToSave);

            state.bWaitCursor = true;
            state.bSearchNewPaquete = true;
            state.newPaqueteName = packageToSave.package.nombre;

            axios.post('/paquetes/' + state.idToken, packageToSave.package).then((res) => {
                state.bWaitCursor = false;
                //console.log('Save new package, res = ', res);

                //console.log('packageToSave.programas = ', packageToSave.programas);

                //Agrega los paquetes al programa:
                if (res.data.paqueteid) {
                    const newPackageID = res.data.paqueteid;
                    axios.post('/programasPaquetes/' + newPackageID + '/' + state.idToken, packageToSave.programas).then((res) => {
                        state.bWaitCursor = false;
                        //console.log('Agregar nuevo paquete a programa, res = ', res);

                        //Agrega la foto al programa, si la hay:
                        if (packageToSave.photoFile !== null) {
                            state.bWaitCursor = true;

                            let formData = new FormData();
                            formData.append('file', packageToSave.photoFile);

                            axios
                                .post('/updloadFile/' + newPackageID + '/' + state.idToken, formData, {
                                    headers: {
                                        'Content-Type': 'multipart/form-data',
                                    },
                                })
                                .then((res) => {
                                    state.bWaitCursor = false;
                                    //console.log('Image file uploaded!');
                                    //Se vuelve a pedir al servidor todos los paquetes:
                                    const packagesInfo = {
                                        planid: packageToSave.planid,
                                        programaid: packageToSave.programas[0].programaid,
                                    };

                                    dispatch('fetchPaquetesPrograma', packagesInfo);
                                });
                        } else {
                            //Se vuelve a pedir al servidor todos los paquetes:
                            const packagesInfo = {
                                planid: packageToSave.planid,
                                programaid: packageToSave.programas[0].programaid,
                            };

                            dispatch('fetchPaquetesPrograma', packagesInfo);
                        }
                    });
                }
            });
        },

        updatePackage({ dispatch, state }, packageToUpdate) {
            if (!state.idToken) {
                return;
            }
            //console.log('Package to update: ', packageToUpdate);

            state.bWaitCursor = true;
            state.bSearchNewPaquete = true;
            state.newPaqueteName = packageToUpdate.package.nombre;

            axios
                .post('/paquetes/' + packageToUpdate.package.paqueteid + '/' + state.idToken, packageToUpdate.package)
                .then((res) => {
                    state.bWaitCursor = false;
                    //console.log('updatePackage, res = ', res);

                    //Agrega los programas nuevos, si los hay:

                    if (packageToUpdate.programasParaAgregar.length > 0) {
                        state.bWaitCursor = true;
                        axios
                            .post('/programasPaquetes/' + packageToUpdate.package.paqueteid + '/' + state.idToken, packageToUpdate.programasParaAgregar)
                            .then((res) => {
                                state.bWaitCursor = false;
                                //console.log('Adding program to package, res = ', res);
                            })
                            .catch((error) => {
                                //console.log('Error agregando programas a paquete. Error = ', error);
                                state.bWaitCursor = false;
                            });
                    }

                    //Borra los progamas deseleccionados, si los hay:

                    if (packageToUpdate.programasParaBorrar.length > 0) {
                        state.bWaitCursor = true;
                        axios
                            .post('/deletePaquete/' + packageToUpdate.package.paqueteid + '/' + state.idToken)
                            .then((res) => {
                                state.bWaitCursor = false;
                                //console.log('Deleting program from package, res = ', res);
                            })
                            .catch((error) => {
                                //console.log('Error borrando programas de paquetes. Error = ', error);
                                state.bWaitCursor = false;
                            });
                    }

                    if (packageToUpdate.photoFile !== null) {
                        state.bWaitCursor = true;

                        let formData = new FormData();
                        formData.append('file', packageToUpdate.photoFile);

                        axios
                            .post('/uploadFile/' + packageToUpdate.package.paqueteid + '/' + state.idToken, formData, {
                                headers: {
                                    'Content-Type': 'multipart/form-data',
                                },
                            })
                            .then((res) => {
                                state.bWaitCursor = false;
                                //console.log('Image file uploaded!');
                                //Se vuelve a pedir al servidor todos los paquetes:
                                const packagesInfo = {
                                    planid: packageToUpdate.planid,
                                    programaid: packageToUpdate.programaid,
                                };

                                dispatch('fetchPaquetesPrograma', packagesInfo);
                            })
                            .catch((error) => {
                                state.bWaitCursor = false;
                                //console.log(error);
                            });
                    } else if (packageToUpdate.deleteImage) {
                        state.bWaitCursor = true;
                        axios
                            .delete('/deleteFile/' + packageToUpdate.package.paqueteid + '/' + state.idToken)
                            .then((res) => {
                                //console.log('DeleteFile, res = ', res);
                                state.bWaitCursor = false;
                                //console.log('Image file deleted!');
                                //Se vuelve a pedir al servidor todos los paquetes:
                                const packagesInfo = {
                                    planid: packageToUpdate.planid,
                                    programaid: packageToUpdate.programaid,
                                };

                                dispatch('fetchPaquetesPrograma', packagesInfo);
                            })
                            .catch((error) => {
                                state.bWaitCursor = false;
                                //console.log(error);
                            });
                    } else {
                        //Se vuelve a pedir al servidor todos los paquetes:
                        const packagesInfo = {
                            planid: packageToUpdate.planid,
                            programaid: packageToUpdate.programaid,
                        };

                        dispatch('fetchPaquetesPrograma', packagesInfo);
                    }
                })
                .catch((error) => {
                    state.bWaitCursor = false;
                    //console.log(error);
                    state.bSearchNewPaquete = false;
                });
        },

        addProgramToPackage({ dispatch, state }, packageInfo) {
            if (!state.idToken) {
                return;
            }

            state.bWaitCursor = true;

            axios
                .get('/programasPaquetes/' + packageInfo.programID + '/' + packageInfo.packageID + '/' + state.idToken, { crossDomain: true })
                .then((res) => {
                    //console.log('res de addProgramToPackage: ', res);
                    state.bWaitCursor = false;
                })
                .catch((error) => {
                    //console.log('Error en addProgramToPackage: ' + error);
                    state.bWaitCursor = false;
                });
        },

        deletePackage({ dispatch, state }, packageInfo) {
            if (!state.idToken) {
                return;
            }

            state.bWaitCursor = true;

            axios.delete('/paquetes/deletePaquete/' + packageInfo.paqueteid + '/' + state.idToken).then((res) => {
                state.bWaitCursor = false;
                dispatch('fetchPaquetesPrograma', packageInfo);
            });
        },

        getMateriasPaqueteAlumno({ dispatch, state }, packageID) {
            if (!state.idToken) {
                return;
            }

            state.bWaitCursor = true;

            axios
                .get('/materias/getMateriaByPaqueteId/' + packageID + '/' + state.idToken, {
                    crossDomain: true,
                })
                .then((res) => {
                    //console.log('res de getMateriaByPaqueteId: ', res);
                    state.bWaitCursor = false;
                    const materias = res.data;
                    dispatch('updateMateriasPaqueteAlumno', materias);
                    dispatch('initMateriasPaqueteAlumno');
                })
                .catch((error) => {
                    //console.log('Error en getMateriasPaquete: ' + error);
                    state.bWaitCursor = false;
                });

            //Inicio pruebas:
            /*const materias = [
                {
                    materiaid: 1,
                    materia: 'Gestión de la ciudad heredada',
                    clave: '80113',
                    descripcion:
                        'En esta materia relacionarás los valores existentes en la ciudad heredada con el bienestar socioambiental y la construcción de identidades locales, en el marco del desarrollo sustentable. Aplicarás herramientas y métodos de valuración para jerrquizar los elementos con valor patrimonial en un contexto urbano. Evaluarás el potencial actual y futuro del patrimonio cultural de una zona urbana, en el marco del desarrollo urbano sustentable.',
                    creditos: 8,
                    paqueteid: 1,
                    prerrequisitos: [],
                    seleccionada: false,
                },
                {
                    materiaid: 2,
                    materia: 'Ciudad de México: morfología y transformación',
                    clave: '80112',
                    descripcion:
                        'En esta materia analizarás la relación entre la forma urbana de las distintas etapas cronológicas de los asentamientos humanos en el Valle de México y las transformacines geográficas, socioeconóicas, culturales y políticas de su entorno, como insumo para comprender su situación actual. Jerarquizarás los factores de mayor incidencia en cada etpapa de transformaci´n urbana para lograr una comprensión sistémica del crecimiento del área urbana. Establecerás una relación causal entre fenómenos físicos y dinámicas socioambientales en el territorio de la zona metropolitana del VAlle de México para visualizar su impacto en materia de urbanismo y bienestar.',
                    creditos: 8,
                    paqueteid: 1,
                    prerrequisitos: [
                        {
                            materiaid: 1,
                            materia: 'Gestión de la ciudad heredada',
                            clave: '80113',
                        },
                    ],
                    seleccionada: false,
                },
                {
                    materiaid: 3,
                    materia: 'El patrimonio edificado en la actualidad',
                    clave: 'PA3',
                    descripcion:
                        'En esta materia relacionarás la evolución de la disciplina de la conservación del patrimonio edificado con las teorías de intervención y restauración arquitectónica. Analizarás el marco normativo aplicable y los cmoponentes de un proceso de restauración arquitectónica. Evaluarás alternativas de intervención en un inmueble con valor patrimonial.',
                    creditos: 8,
                    paqueteid: 1,
                    prerrequisitos: [
                        {
                            materiaid: 1,
                            materia: 'Gestión de la ciudad heredada',
                            clave: '80113',
                        },
                        {
                            materiaid: 2,
                            materia: 'Ciudad de México: morfología y transformación',
                            clave: '80112',
                        },
                    ],
                    seleccionada: false,
                },
            ];

            dispatch('updateMateriasPaqueteAlumno', materias);
            //Selecciona las materias seleccionadas por el usuario:
            dispatch('initMateriasPaqueteAlumno');*/
            //Fin pruebas
        },

        updateMateriasPaqueteAlumno({ commit }, materias) {
            commit('setMateriasPaqueteAlumno', materias);
        },

        initMateriasPaqueteAlumno({ state }) {
            //Desselecciona todas las materias:
            for (let i = 0; i < state.materiasPaqueteAlumno.length; i++) {
                state.materiasPaqueteAlumno[i].seleccionada = false;
            }

            //Selecciona las materias seleccionadas por el usuario:
            for (let i = 0; i < state.userAOCs.materias.length; i++) {
                var bMateriaEncontrada = false;
                for (let j = 0; j < state.materiasPaqueteAlumno.length; j++) {
                    if (state.materiasPaqueteAlumno[j].materiaid === state.userAOCs.materias[i].materiaid) {
                        state.materiasPaqueteAlumno[j].seleccionada = true;
                        bMateriaEncontrada = true;
                        break;
                    }
                }
            }
        },

        updatePlan({ commit, state }, plan) {
            commit('setPlan', plan);
        },

        updateMateriasPaquete({ commit, state }, materias) {
            commit('setMateriasPaquete', materias);
            state.bMateriasPaqueteLoaded = true;
            //console.log('bMateriasPaqueteLoaded = ', state.bMateriasPaqueteLoaded);
            state.bLoadingData = false;
        },

        updatePaquetesProgramaLoaded({ commit }, bLoaded) {
            commit('setPaquetesProgramaLoaded', bLoaded);
        },

        updateMateriasPaqueteLoaded({ commit }, bLoaded) {
            commit('setMateriasPaqueteLoaded', bLoaded);
        },

        updateMateriaLoaded({ commit }, bLoaded) {
            commit('setMateriaLoaded', bLoaded);
        },

        updateNoPrerreqLoaded({ commit }, bLoaded) {
            commit('setNoPrerreqLoaded', bLoaded);
        },

        updateLoadingData({ commit }, bLoading) {
            commit('setLoadingData', bLoading);
        },

        getMateria({ dispatch, state }, materiaID) {
            state.bWaitCursor = true;

            axios
                .get('/materias/getById/' + materiaID + '/' + state.idToken, {
                    crossDomain: true,
                })
                .then((res) => {
                    //console.log('geMateria, res = ', res);
                    const materia = res.data;
                    if (materia.materiaid !== 0) {
                        //console.log('getMateria, materia = ', materia);
                        dispatch('updateMateria', materia);
                    }

                    state.bWaitCursor = false;
                })
                .catch((error) => {
                    //console.log('Error en getMateria, error = ', error);
                    state.bWaitCursor = false;
                });

            //Inicio pruebas:
            /*var materia = {
                materiaid: 1,
                materia: 'Gestión Cultural',
                clave: '22377',
                creditos: 8,
                descripcion:
                    'En esta materia se desarrollarán proyectos de gestión cultural independientes o en el marco de alguna instancia ppublica o privada, con base en la elaboración de una propuesta que considere aspectos de planeación, gestión, administración  producción del reconocimiento del papel que desempeña el mercado del arte, a partir del ejercicio crítico del discernimiento para ejercer liderazgo y alcanzar la incidencia social a partir del trabajo colaborativo.',
                prerrequisitos: [],
            };

            dispatch('updateMateria', materia);
            state.bWaitCursor = false;
            */
            //Fin pruebas.
        },

        getNoPrerreq({ dispatch, state }, materiaID) {
            state.bWaitCursor = true;

            axios
                .get('/materias/getById/' + materiaID + '/' + state.idToken, {
                    crossDomain: true,
                })
                .then((res) => {
                    //console.log('geMateria, res = ', res);
                    const materia = res.data;
                    if (materia.materiaid !== 0) {
                        //console.log('getNoPrerreq, materia = ', materia);
                        dispatch('updateNoPrerreq', materia);
                    }

                    state.bWaitCursor = false;
                })
                .catch((error) => {
                    //console.log('Error en getMateria, error = ', error);
                    state.bWaitCursor = false;
                });

            //Inicio pruebas:
            // var materia = {
            //     materiaid: 2,
            //     materia: 'Proyectos II',
            //     clave: '21532',
            //     sigla: 'AQ072',
            //     creditos: 8,
            //     horas: 6,
            //     semestreIdeal: 2,
            //     prerrequisitos: [
            //         {
            //             materiaid: 1,
            //             materia: 'Proyectos I',
            //             clave: '21531'
            //         }
            //     ],
            //     obligatoria: true,
            //     descripcion:
            //         'Desarrollo de un programa arquitectónico y diagrama de funcionamiento que sirvan como punto de partida para proyectar un espacio habitable de baja complejidad.',
            //     categoriaid: 1,
            //     areaid: 1,
            //     secuenciaFormativaid: 1, //Enfoque
            //     opcionid: 1 //Construcción
            // };

            // dispatch('updateNoPrerreq', materia);
            // state.bWaitCursor = false;

            //Fin pruebas.
        },

        updateMateria({ commit, state }, materia) {
            commit('setMateria', materia);
            state.bMateriaLoaded = true;
            state.bLoadingData = false;
        },

        updateNoPrerreq({ commit, state }, materia) {
            commit('setNoPrerreq', materia);
            state.bNoPrerreqLoaded = true;
            state.bLoadingData = false;
        },

        updateServerResponse({ commit }, bResponse) {
            commit('setServerResponse', bResponse);
        },

        fetchUsers({ commit, state }) {
            //En esta función se obtienen los usuarios administradores, no los de las encuestas.
            state.bWaitCursor = true;

            axios
                .get('/usuarios/' + state.idToken, { crossDomain: true })
                .then((res) => {
                    //console.log('res de fetchUsuarios: ', res);
                    const users = res.data;
                    commit('setUsers', users);
                    state.bWaitCursor = false;
                })
                .catch((error) => {
                    //console.log(error);
                    state.bWaitCursor = false;
                });
        },

        fetchAdministrators({ commit, state }) {
            state.bWaitCursor = true;

            axios
                .get('/usuarios/getAdmin/' + state.idToken, { crossDomain: true })
                .then((res) => {
                    const data = res.data;
                    //console.log('res de administradores: ', data);
                    const users = [];
                    var i;
                    for (i = 0; i < data.length; i++) {
                        const user = data[i];
                        users.push(user);
                    }
                    state.bWaitCursor = false;
                    //console.log('Administrators: ', users);
                    commit('setAdministrators', users);
                })
                .catch((error) => {
                    //console.log(error);
                    state.bWaitCursor = false;
                });
        },

        setDuplicatedUserError({ commit }, payload) {
            commit('setDuplicatedUserError', payload);
        },

        saveNewUser({ dispatch, state }, newUser) {
            //Checa que no haya un usuario registado con el mismo correo:

            state.bWaitCursor = true;
            //console.log('email: ', newUser.email);

            axios
                .get('/usuarios/getByEmail/' + newUser.email + '/' + state.idToken, {
                    crossDomain: true,
                })
                .then((res) => {
                    state.bWaitCursor = false;
                    const data = res.data;
                    //console.log('New User, res = ', data);
                    if (data.usuarioid === 0) {
                        //No se encontró un usuario con ese correo...
                        //console.log("Todo bien, podemos registrar usuario...");
                        dispatch('storeNewUser', newUser);
                    } //Ya hay un usuario con ese correo...
                    else {
                        dispatch('setDuplicatedUserError', true);
                    }
                })
                .catch((error) => {
                    //console.log(error);
                    state.bWaitCursor = false;
                });
        },

        storeNewUser({ dispatch, state }, newUser) {
            if (!state.idToken) {
                return;
            }

            state.bWaitCursor = true;
            state.bSearchNewUser = true;
            state.newUserEmail = newUser.email;

            //console.log('User to save: ', newUser);

            axios
                .post('/usuarios/' + state.idToken, newUser)
                .then((res) => {
                    state.bWaitCursor = false;
                    //console.log("res de CreateUser: ", res);
                    //Se vuelve a pedir al servidor todos los usuarios:
                    dispatch('fetchUsers');
                })
                .catch((error) => {
                    //console.log(error);
                    state.bWaitCursor = false;
                    state.bSearchNewUser = false;
                    state.newUserEmail = '';
                });
        },

        editUser({ dispatch, state }, user) {
            state.bWaitCursor = true;

            //console.log('user = ', user);

            //Si el objeto user trae password quiere decir que hay que editar el password:
            //console.log('user.password = ', user.password);
            if (user.password !== '') {
                //Cambia el password en la tabla de autenticación:
                //console.log('Cambiando Password...');

                //Se crea un objeto con el ID y el password:
                const userPasswd = {
                    usuariosid: user.usuarioid,
                    password: user.password,
                };

                axios
                    .post('/usuarios/updateUserPassword/' + userPasswd.usuariosid + '/' + state.idToken, userPasswd)
                    .then((res) => {
                        state.bWaitCursor = false;
                    })
                    .catch((error) => {
                        //console.log(error);
                        state.bWaitCursor = false;
                    });
            }

            //Edición de los datos del usuario:
            const userData = {
                usuarioid: user.usuarioid,
                activo: user.activo,
                email: user.email,
                nombre: user.nombre,
                apPaterno: user.apPaterno,
                apMaterno: user.apMaterno,
                empresaid: user.empresaid,
                tipoid: user.tipoid,
                cuestionarioid: user.cuestionarioid,
                numLicencias: user.numLicencias,
            };
            //console.log('user to save: ', userData);
            state.bWaitCursor = true;
            axios
                .post('/usuarios/' + user.usuarioid + '/' + state.idToken, userData)
                .then((res) => {
                    state.bWaitCursor = false;
                    //console.log('res de Edición de Usuario: ', res);
                    //Se vuelve a pedir al servidor todos los usuarios:
                    dispatch('fetchUsers');
                })
                .catch((error) => {
                    //console.log(error);
                    state.bWaitCursor = false;
                    state.bSearchNewUser = false;
                });
        },
        updateSelectedUserIndex({ commit }, index) {
            commit('updateSelectedUserIndex', index);
        },

        updateSelectedPlanIndex({ commit }, index) {
            commit('updateSelectedPlanIndex', index);
        },

        updateSelectedCourseIndex({ commit }, index) {
            commit('updateSelectedCourseIndex', index);
        },

        updateSelectedDivisionIndex({ commit }, index) {
            commit('updateSelectedDivisionIndex', index);
        },

        updateSelectedPaqueteIndex({ commit }, index) {
            commit('updateSelectedPaqueteIndex', index);
        },

        deleteUser({ dispatch, state }, userID) {
            if (!state.idToken) {
                return;
            }

            state.bWaitCursor = true;

            axios
                .delete('/usuarios/deleteUser/' + userID + '/0/' + state.idToken)
                .then((res) => {
                    state.bWaitCursor = false;
                    //Se vuelve a pedir al servidor todos los usuarios:
                    dispatch('fetchUsers');
                })
                .catch((error) => {
                    //console.log(error);
                    state.bWaitCursor = false;
                });
        },

        updatePlanesEstudios({ commit, state }, planes) {
            if (!state.idToken) {
                return;
            }
            commit('setPlanesEstudios', planes);
        },

        editPlan({ dispatch, state }, planInfo) {
            if (!state.idToken) {
                return;
            }

            state.bWaitCursor = true;
            state.bSearchNewPlanEstudios = true;
            state.newPlanName = planInfo.nombrePlan;

            //console.log('Plan  to save= ', planInfo);

            axios
                .post('/planes/' + state.idToken, planInfo)
                .then((res) => {
                    state.bWaitCursor = false;
                    //console.log('res de Edición de Plan de Estudios: ', res);
                    //Se vuelve a pedir al servidor todos los planes:
                    dispatch('fetchPlanesEstudios');
                })
                .catch((error) => {
                    //console.log(error);
                    state.bWaitCursor = false;
                    state.bSearchNewPlanEstudios = false;
                    state.newPlanName = '';
                });
        },

        saveNewPlan({ dispatch, state }, planInfo) {
            if (!state.idToken) {
                return;
            }

            state.bWaitCursor = true;
            state.bSearchNewPlanEstudios = true;
            state.newPlanName = planInfo.nombrePlan;

            //console.log('Plan  to save= ', planInfo);

            axios
                .post('/planes/' + state.idToken, planInfo)
                .then((res) => {
                    state.bWaitCursor = false;
                    //console.log('res de Registro de Plan de Estudios: ', res);
                    //Se vuelve a pedir al servidor todos los planes:
                    dispatch('fetchPlanesEstudios');
                })
                .catch((error) => {
                    //console.log(error);
                    state.bWaitCursor = false;
                    state.bSearchNewPlanEstudios = false;
                    state.newPlanName = '';
                });
        },

        deletePlan({ dispatch, state }, planID) {
            if (!state.idToken) {
                return;
            }

            state.bWaitCursor = true;

            axios
                .delete('/planes/deletePlan/' + planID + '/' + state.idToken)
                .then((res) => {
                    state.bWaitCursor = false;
                    //Se vuelve a pedir al servidor todos los planes de estudios:
                    dispatch('fetchPlanesEstudios');
                })
                .catch((error) => {
                    //console.log(error);
                    state.bWaitCursor = false;
                });
        },

        editCourse({ dispatch, state }, courseInfo) {
            if (!state.idToken) {
                return;
            }

            state.bWaitCursor = true;
            state.bSearchNewCourse = true;
            state.newCourseName = courseInfo.materia;

            //console.log('Course  to save= ', courseInfo);

            axios
                .post('/materias/' + state.idToken, courseInfo)
                .then((res) => {
                    state.bWaitCursor = false;
                    //console.log('res de Edición de Materia: ', res);
                    //Se vuelve a pedir al servidor todas las materias del plan:
                    dispatch('fetchMateriasPaquete', courseInfo.paqueteid);
                })
                .catch((error) => {
                    //console.log(error);
                    state.bWaitCursor = false;
                    state.bSearchNewCourse = false;
                    state.newCourseName = '';
                });
        },

        saveNewCourse({ dispatch, state }, courseInfo) {
            if (!state.idToken) {
                return;
            }

            state.bWaitCursor = true;
            state.bSearchNewCourse = true;
            state.newCourseName = courseInfo.materia;

            //console.log('Course  to save= ', courseInfo);

            axios
                .post('/materias/' + state.idToken, courseInfo)
                .then((res) => {
                    state.bWaitCursor = false;
                    //console.log('res de Registro de materia: ', res);
                    dispatch('updateMateriaID', res.data.materiaid);
                    //Se vuelve a pedir al servidor todas las materias del plan:
                    dispatch('fetchMateriasPaquete', courseInfo.paqueteid);
                })
                .catch((error) => {
                    //console.log(error);
                    state.bWaitCursor = false;
                    state.bSearchNewCourse = false;
                    state.newCourseName = '';
                });
        },

        deleteCourse({ dispatch, state }, courseInfo) {
            if (!state.idToken) {
                return;
            }

            state.bWaitCursor = true;

            axios
                .delete('/materias/deleteMateria/' + courseInfo.materiaID + '/' + state.idToken)
                .then((res) => {
                    state.bWaitCursor = false;
                    //Se vuelve a pedir al servidor todas las materias:
                    dispatch('fetchMateriasPaquete', courseInfo.paqueteID);
                })
                .catch((error) => {
                    //console.log(error);
                    state.bWaitCursor = false;
                });
        },

        updateShowSequenceOptionsDlg({ commit, state }, bShowDlg) {
            if (!state.idToken) {
                return;
            }

            commit('setShowSequenceOptionsDlg', bShowDlg);
        },

        updateSequenceOptionID({ commit, state }, optionID) {
            if (!state.idToken) {
                return;
            }
            commit('setSequenceOptionID', optionID);
        },

        updateMateriaID({ commit, state }, materiaID) {
            if (!state.idToken) {
                return;
            }

            commit('setMateriaID', materiaID);
        },

        updateCaptchaOK({ commit }, captchaOK) {
            commit('setCaptchaOK', captchaOK);
        },

        updateSubmittingRecaptcha({ commit }, submitting) {
            commit('setSubmittingRecaptcha', submitting);
        },

        fetchDivisiones({ dispatch, state }) {
            state.bWaitCursor = true;

            axios
                .get('/divisiones/' + state.idToken, { crossDomain: true })
                .then((res) => {
                    //console.log('fetchDivisiones, res = ', res);
                    const divisiones = res.data;
                    state.bWaitCursor = false;
                    dispatch('updateDivisiones', divisiones);
                })
                .catch((error) => {
                    //console.log('Error en fetchDivisiones, error = ', error);
                    state.bWaitCursor = false;
                });

            //Inicio pruebas:
            /*var divisiones = [
                {
                    divisionid: 1,
                    nombre: 'División de Humanidades y Comunicación',
                    sigla: 'DHyC',
                    departamentos: [
                        {
                            departamentoid: 1,
                            nombre: 'Arte',
                            sigla: 'Arte',
                            programas: [
                                {
                                    programaid: 1,
                                    nombre: 'Historia del Arte',
                                },
                            ],
                        },
                        {
                            departamentoid: 2,
                            nombre: 'Ciencias Religiosas',
                            sigla: 'Ciencias Religiosas',
                            programas: [
                                {
                                    programaid: 1,
                                    nombre: 'Ciencias Teológicas',
                                },
                            ],
                        },
                        {
                            departamentoid: 3,
                            nombre: 'Comunicación',
                            sigla: 'Comunicación',
                            programas: [
                                {
                                    programaid: 1,
                                    nombre: 'Comunicación',
                                },
                            ],
                        },
                        {
                            departamentoid: 4,
                            nombre: 'Educación',
                            sigla: 'Educación',
                            programas: [
                                {
                                    programaid: 1,
                                    nombre: 'Pedagogía',
                                },
                            ],
                        },
                        {
                            departamentoid: 5,
                            nombre: 'Filosofía',
                            sigla: 'Filosofía',
                            programas: [
                                {
                                    programaid: 1,
                                    nombre: 'Filosofía',
                                },
                            ],
                        },
                        {
                            departamentoid: 6,
                            nombre: 'Historia',
                            sigla: 'Historia',
                            programas: [
                                {
                                    programaid: 1,
                                    nombre: 'Historia',
                                },
                            ],
                        },
                        {
                            departamentoid: 7,
                            nombre: 'Letras',
                            sigla: 'Letras',
                            programas: [
                                {
                                    programaid: 1,
                                    nombre: 'Literatura Latinoamericana',
                                },
                            ],
                        },
                    ],
                },
                {
                    divisionid: 2,
                    nombre: 'División de Estudios Sociales',
                    sigla: 'DES',
                    departamentos: [
                        {
                            departamentoid: 1,
                            nombre: 'Ciencias Sociales y Políticas',
                            sigla: 'Ciencias Sociales y Políticas',
                            programas: [
                                {
                                    programaid: 1,
                                    nombre: 'Ciencias Políticas y Administración Pública',
                                },
                                {
                                    programaid: 2,
                                    nombre: 'Ciencias Sociales',
                                },
                            ],
                        },
                        {
                            departamentoid: 2,
                            nombre: 'Derecho',
                            sigla: 'Derecho',
                            programas: [
                                {
                                    programaid: 1,
                                    nombre: 'Derecho',
                                },
                            ],
                        },
                        {
                            departamentoid: 3,
                            nombre: 'Economía',
                            sigla: 'Economía',
                            programas: [
                                {
                                    programaid: 1,
                                    nombre: 'Economía',
                                },
                            ],
                        },
                        {
                            departamentoid: 4,
                            nombre: 'Estudios Empresariales',
                            sigla: 'Estudios Empresariales',
                            programas: [
                                {
                                    programaid: 1,
                                    nombre: 'Administración de Empresas',
                                },
                                {
                                    programaid: 2,
                                    nombre: 'Finanzas',
                                },
                                {
                                    programaid: 3,
                                    nombre: 'Mercadotecnia',
                                },
                            ],
                        },
                        {
                            departamentoid: 5,
                            nombre: 'Estudios Internacionales',
                            sigla: 'Estudios Internacionales',
                            programas: [
                                {
                                    programaid: 1,
                                    nombre: 'Relaciones Internacionales',
                                },
                            ],
                        },
                        {
                            departamentoid: 6,
                            nombre: 'Psicología',
                            sigla: 'Psicología',
                            programas: [
                                {
                                    programaid: 1,
                                    nombre: 'Psicología',
                                },
                            ],
                        },
                        {
                            departamentoid: 7,
                            nombre: 'Salud',
                            sigla: 'Salud',
                            programas: [
                                {
                                    programaid: 1,
                                    nombre: 'Nutrición y Ciencia de los Alimentos',
                                },
                            ],
                        },
                    ],
                },
                {
                    divisionid: 3,
                    nombre: 'División de Ciencia, Arte y Tecnología',
                    sigla: 'DiCAT',
                    departamentos: [
                        {
                            departamentoid: 1,
                            nombre: 'Arquitectura, Urbanismo e Ingeniería Civil',
                            sigla: 'DAUIC',
                            programas: [
                                {
                                    programaid: 1,
                                    nombre: 'Arquitectura',
                                },
                                {
                                    programaid: 2,
                                    nombre: 'Ingeniería Civil',
                                },
                            ],
                        },
                        {
                            departamentoid: 2,
                            nombre: 'CENTRUS',
                            sigla: 'CENTRUS',
                            programas: [
                                {
                                    programaid: 1,
                                    nombre: 'Sustentabilidad',
                                },
                            ],
                        },
                        {
                            departamentoid: 3,
                            nombre: 'Diseño',
                            sigla: 'Diseño',
                            programas: [
                                {
                                    programaid: 1,
                                    nombre: 'Diseño de productos y experiencias',
                                },
                                {
                                    programaid: 2,
                                    nombre: 'Diseño sensorial y dirección creativa',
                                },
                            ],
                        },
                        {
                            departamentoid: 4,
                            nombre: 'Estudios en Ingeniería para la Innovación',
                            sigla: 'DEII',
                            programas: [
                                {
                                    programaid: 1,
                                    nombre: 'Transformación Digital',
                                },
                            ],
                        },
                        {
                            departamentoid: 5,
                            nombre: 'Física y Matemáticas',
                            sigla: 'Física y Matemáticas',
                            programas: [
                                {
                                    programaid: 1,
                                    nombre: 'Ingeniería Física',
                                },
                            ],
                        },
                        {
                            departamentoid: 6,
                            nombre: 'Ingeniería Química, Industrial y de Alimentos',
                            sigla: 'DIQIA',
                            programas: [
                                {
                                    programaid: 1,
                                    nombre: 'Ingeniería en Alimentos',
                                },
                                {
                                    programaid: 2,
                                    nombre: 'Ingeniería Industrial',
                                },

                                {
                                    programaid: 3,
                                    nombre: 'Ingeniería Químimca',
                                },
                                {
                                    programaid: 4,
                                    nombre: 'Química',
                                },
                            ],
                        },
                        {
                            departamentoid: 7,
                            nombre: 'INIAT',
                            sigla: 'INIAT',
                            programas: [
                                {
                                    programaid: 1,
                                    nombre: 'INIAT',
                                },
                            ],
                        },
                    ],
                },
            ];

            dispatch('updateDivisiones', divisiones);
            state.bWaitCursor = false;
            */
            //Fin Pruebas.
        },

        updateDivisiones({ commit }, divisiones) {
            commit('setDivisiones', divisiones);
        },

        editDivision({ dispatch, state }, divisionInfo) {
            if (!state.idToken) {
                return;
            }

            state.bWaitCursor = true;
            state.bSearchDivision = true;
            state.divisionNameToLookFor = divisionInfo.division;

            //console.log('division  to save= ', divisionInfo);

            axios
                .post('/divisiones/' + divisionInfo.divisionid + '/' + state.idToken, divisionInfo)
                .then((res) => {
                    state.bWaitCursor = false;
                    //console.log('res de Edición de División: ', res);
                    //Se vuelve a pedir al servidor todas las divisiones:
                    dispatch('fetchDivisiones');
                })
                .catch((error) => {
                    //console.log(error);
                    state.bWaitCursor = false;
                    state.bSearchDivision = false;
                    state.divisionNameToLookFor = '';
                });
        },

        saveNewDivision({ dispatch, state }, divisionInfo) {
            if (!state.idToken) {
                return;
            }

            state.bWaitCursor = true;
            state.bSearchDivision = true;
            state.divisionNameToLookFor = divisionInfo.nombre;

            //console.log('Division to save: ', divisionInfo);

            axios
                .post('/divisiones/' + state.idToken, divisionInfo)
                .then((res) => {
                    state.bWaitCursor = false;
                    //console.log('res de saveNewDivision: ', res);
                    //Se vuelve a pedir al servidor todas las divisiones:
                    dispatch('fetchDivisiones');
                })
                .catch((error) => {
                    //console.log(error);
                    state.bWaitCursor = false;
                    state.bSearchDivision = false;
                    state.divisionNameToLookFor = '';
                });
        },

        deleteDivision({ dispatch, state }, divisionID) {
            if (!state.idToken) {
                return;
            }

            state.bWaitCursor = true;

            axios
                .delete('/divisiones/deleteDivision/' + divisionID + '/' + state.idToken)
                .then((res) => {
                    state.bWaitCursor = false;
                    //Se vuelve a pedir al servidor todas las divisiones:
                    dispatch('fetchDivisiones');
                })
                .catch((error) => {
                    //console.log(error);
                    state.bWaitCursor = false;
                });
        },

        editDepartment({ dispatch, state }, departmentToSave) {
            if (!state.idToken) {
                return;
            }

            state.bWaitCursor = true;
            state.bSearchDivision = true; //Para poder volver a seleccionarla después, cuando se vuelvan a pedir todas las divisiones.
            state.divisionNameToLookFor = departmentToSave.division;

            const departmentInfo = {
                divisionid: departmentToSave.divisionid,
                departamentoid: departmentToSave.departamentoid,
                nombre: departmentToSave.nombre,
                sigla: departmentToSave.sigla,
            };

            //console.log('department  to edit= ', departmentInfo);

            axios
                .post('/departamentos/' + departmentInfo.departamentoid + '/' + state.idToken, departmentInfo)
                .then((res) => {
                    state.bWaitCursor = false;
                    //console.log('res de Edición de departamento: ', res);
                    //Se vuelve a pedir al servidor todas las divisiones:
                    dispatch('fetchDivisiones');
                })
                .catch((error) => {
                    //console.log(error);
                    state.bWaitCursor = false;
                    state.bSearchDivision = false;
                    state.divisionNameToLookFor = '';
                });
        },

        saveNewDepartment({ dispatch, state }, departmentToSave) {
            if (!state.idToken) {
                return;
            }

            state.bWaitCursor = true;
            state.bSearchDivision = true;
            state.divisionNameToLookFor = departmentToSave.division;

            const departmentInfo = {
                divisionid: departmentToSave.divisionid,
                departamentoid: departmentToSave.departamentoid,
                nombre: departmentToSave.nombre,
                sigla: departmentToSave.sigla,
            };

            //console.log('Department to save: ', departmentInfo);

            axios
                .post('/departamentos/' + state.idToken, departmentInfo)
                .then((res) => {
                    state.bWaitCursor = false;
                    //console.log('res de saveNewDepartment: ', res);
                    //Se vuelve a pedir al servidor todas las divisiones:
                    dispatch('fetchDivisiones');
                })
                .catch((error) => {
                    //console.log(error);
                    state.bWaitCursor = false;
                    state.bSearchDivision = false;
                    state.divisionNameToLookFor = '';
                });
        },

        deleteDepartment({ dispatch, state }, departmentID) {
            if (!state.idToken) {
                return;
            }

            state.bWaitCursor = true;

            axios
                .delete('/departamentos/deleteDepartamento/' + departmentID + '/' + state.idToken)
                .then((res) => {
                    state.bWaitCursor = false;
                    //console.log('res de deletDepartment: ', res);
                })
                .catch((error) => {
                    //console.log(error);
                    state.bWaitCursor = false;
                });
        },

        editProgram({ dispatch, state }, programToSave) {
            if (!state.idToken) {
                return;
            }

            state.bWaitCursor = true;
            state.bSearchDivision = true; //Para poder volver a seleccionarla después, cuando se vuelvan a pedir todas las divisiones.
            state.divisionNameToLookFor = programToSave.division;

            const programInfo = {
                departamentoid: programToSave.departamentoid,
                programaid: programToSave.programaid,
                nombre: programToSave.nombre,
            };

            //console.log('Program  to edit= ', programInfo);

            axios
                .post('/programas/' + programInfo.programaid + '/' + state.idToken, programInfo)
                .then((res) => {
                    state.bWaitCursor = false;
                    //console.log('res de Edición de programa: ', res);
                    //Se vuelve a pedir al servidor todas las divisiones:
                    dispatch('fetchDivisiones');
                })
                .catch((error) => {
                    //console.log(error);
                    state.bWaitCursor = false;
                    state.bSearchDivision = false;
                    state.divisionNameToLookFor = '';
                });
        },

        saveNewProgram({ dispatch, state }, programToSave) {
            if (!state.idToken) {
                return;
            }

            state.bWaitCursor = true;
            state.bSearchDivision = true;
            state.divisionNameToLookFor = programToSave.division;

            const programInfo = {
                departamentoid: programToSave.departamentoid,
                programaid: programToSave.programaid,
                nombre: programToSave.nombre,
            };

            //('Program to save: ', programInfo);

            axios
                .post('/programas/' + state.idToken, programInfo)
                .then((res) => {
                    state.bWaitCursor = false;
                    //console.log('res de saveNewProgram: ', res);
                    //Se vuelve a pedir al servidor todas las divisiones:
                    dispatch('fetchDivisiones');
                })
                .catch((error) => {
                    //console.log(error);
                    state.bWaitCursor = false;
                    state.bSearchDivision = false;
                    state.divisionNameToLookFor = '';
                });
        },

        deleteProgram({ dispatch, state }, programID) {
            if (!state.idToken) {
                return;
            }

            state.bWaitCursor = true;

            //console.log('/programas/deletePrograma/' + programID + '/' + state.idToken);
            axios
                .delete('/programas/deletePrograma/' + programID + '/' + state.idToken)
                .then((res) => {
                    state.bWaitCursor = false;
                    //console.log('deleteProgram, res = ', res);
                })
                .catch((error) => {
                    //console.log(error);
                    state.bWaitCursor = false;
                });
        },

        updateShowPackageInfoDlg({ commit }, bShow) {
            commit('setShowPackageInfoDlg', bShow);
        },

        updateForceRedraw({ commit }, bRedraw) {
            commit('setForceRedraw', bRedraw);
        },

        updateMyAOCsDlg({ commit }, bShow) {
            commit('setMyAOCsDlg', bShow);
        },

        updateShowHeader({ commit }, bShow) {
            commit('setShowHeader', bShow);
        },
    },

    getters: {
        version: (state) => {
            return state.version;
        },
        appTitle: (state) => {
            return state.appTitle;
        },
        uiaLogoBlanco: (state) => {
            return state.uiaLogoBlanco;
        },
        uiaLogoRojo: (state) => {
            return state.uiaLogoRojo;
        },
        uiaLogoPositivo: (state) => {
            return state.uiaLogoPositivo;
        },
        uiaRubricaSimple: (state) => {
            return state.uiaRubricaSimple;
        },
        logoAOCS: (state) => {
            return state.logoAOCS;
        },
        waitCursor: (state) => {
            return state.bWaitCursor;
        },
        failedLogin: (state) => {
            return state.bFailedLogin;
        },
        inactiveUser: (state) => {
            return state.bInactiveUser;
        },
        isAuthenticated(state) {
            return state.idToken !== null && state.idToken !== undefined;
        },
        duplicatedUserError(state) {
            return state.bDuplicatedUserError;
        },
        user(state) {
            return state.user;
        },
        userID(state) {
            return state.userID;
        },
        userName(state) {
            return state.userName;
        },
        carrera(state) {
            return state.user.carrera;
        },
        numCuenta(state) {
            return state.numCuenta;
        },
        // semestre(state) {
        //     return state.semestre;
        // },
        periodoInicioID(state) {
            return state.periodoInicioID;
        },
        anioInicio(state) {
            return state.anioInicio;
        },
        loggedUserID(state) {
            return state.userID;
        },

        userType(state) {
            return state.user.tipoid;
        },

        isAdmin(state) {
            return state.bAdmin;
            //return false;
        },

        userTypes(state) {
            return state.userTypes;
        },
        selectedUserTypeIndex: (state) => {
            return state.selectedUserTypeIndex;
        },
        serverResponse(state) {
            return state.bServerResponse;
        },
        users(state) {
            return state.users;
        },
        administrators(state) {
            return state.administrators;
        },
        selectedUserIndex: (state) => {
            return state.selectedUserIndex;
        },
        selectedPlanIndex: (state) => {
            return state.selectedPlanIndex;
        },
        selectedCourseIndex: (state) => {
            return state.selectedCourseIndex;
        },
        selectedDivisionIndex: (state) => {
            return state.selectedDivisionIndex;
        },
        selectedPaqueteIndex: (state) => {
            return state.selectedPaqueteIndex;
        },
        semestres: (state) => {
            return state.semestres;
        },
        divisiones: (state) => {
            return state.divisiones;
        },
        planesEstudios: (state) => {
            return state.planesEstudios;
        },
        planEstudios: (state) => {
            return state.planEstudios;
        },
        paquetesPrograma: (state) => {
            return state.paquetesPrograma;
        },
        packageImg(state) {
            return state.packageImg;
        },
        materiasPaquete: (state) => {
            return state.materiasPaquete;
        },
        materia: (state) => {
            return state.materia;
        },
        noPrerreq: (state) => {
            return state.noPrerreq;
        },
        paquetesProgramaLoaded(state) {
            return state.bPaquetesProgramaLoaded;
        },
        materiasPaqueteLoaded(state) {
            return state.bMateriasPaqueteLoaded;
        },
        materiaLoaded(state) {
            return state.bMateriaLoaded;
        },
        noPrerreqLoaded(state) {
            return state.bNoPrerreqLoaded;
        },
        loadingData(state) {
            return state.bLoadingData;
        },
        showSequenceOptionsDlg(state) {
            return state.bShowSequenceOptionsDlg;
        },
        sequenceOptionID(state) {
            return state.sequenceOptionID;
        },
        materiaID(state) {
            return state.materiaID;
        },
        captchaOK(state) {
            return state.bCaptchaOK;
        },
        submittingRecaptcha(state) {
            return state.bSubmittingRecaptcha;
        },
        divisionFound(state) {
            return state.bDivisionFound;
        },

        catalogoAOCs(state) {
            return state.catalogoAOCs;
        },

        showAOCsByPackage(state) {
            return state.bShowAOCsByPackage;
        },

        userAOCs(state) {
            return state.userAOCs;
        },

        showPackageInfoDlg(state) {
            return state.bShowPackageInfoDlg;
        },

        materiasPaqueteAlumno(state) {
            return state.materiasPaqueteAlumno;
        },

        forceRedraw(state) {
            return state.bForceRedraw;
        },

        myAOCsDlg(state) {
            return state.bMyAOCsDlg;
        },

        showHeader(state) {
            return state.bShowHeader;
        },
    },
});
